import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Building} from '../models/building.model';

@Injectable({
  providedIn: 'root'
})
export class BuildingService {

  private api:string = environment.api + '/buildings';

  constructor(private http: HttpClient) { }

  public findAllBuildings(){
    return this.http.get(this.api + '/findAll'+'?&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId);
  }

  public createBuilding(building:Building){
    console.log(building)
    
    return this.http.post(this.api,building);
  }

  public updateBuilding(building:Building){
    return this.http.put(this.api,building);
  }

  public deletebuilding(building:Building){
    return this.http.delete(this.api + '/' + building.buildingId);
  }

  public findBuildingsByZoneId(id){
    return this.http.get(this.api + '/buildingsZone/' + id);
  } 
}
